import session from '../util/session'

export interface QuizElement extends HTMLElement {
  startQuiz: () => Promise<void>
}

up.compiler(
  '[data-quiz]',
  (element: HTMLElement, { lazy = false }: { lazy?: boolean | string }) => {
    let started = false
    const quizElement = element as QuizElement
    quizElement.startQuiz = async () => {
      if (!started) {
        started = true

        const { mountQuiz } = await import('../quiz/component')

        if (element.isConnected) {
          const destroy = mountQuiz(element, session.userName ?? '')
          up.destructor(element, destroy)
        }
      }
    }

    if (!lazy || lazy === 'false') void quizElement.startQuiz()
  },
)
